import axios from 'axios';

import c from '../helpers/constants';

export function getProducts() {
  return (
    axios({
      url: c.API_ENDPOINTS.PRODUCTS,
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then((response: any) => {
        return response?.data;
      })
      .catch((error: any) => {
        return error.response?.data;
      })
  );
}
